export const claimsStatusOnlyOneClaim = [
  20101,
  20102,
  30101,
  30102,
  30103,
  30104,
];
